<template>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">
        {{ $t('listeProduitReseauNumerique.title') }}
      </h1>
      <breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template #action>
      <qd-button
        @click="checkPermissions(permCatalogue.maj)
          ? $router.push({ name: 'm.bodac.catalogue-nouveauReseauNumerique' })
          : showPopUp()"
        :class="{ 'button-access-no-permission': !checkPermissions(permCatalogue.maj) }"
        class="button is-addOrEdit">
        {{ $t('listeProduitReseauNumerique.actions.add') }}
      </qd-button>
    </template>
    <template #bar-left>
      <div class="column is-narrow">
        <selecteur-action
          :options="[]"
          :placeholder="$t('general.placeHolder.groupedAction')"
          :titleButton="'general.button.apply'"
          :elementsSelectionnes="getAllProduitReseauNumerique().length > 0"
        ></selecteur-action>
      </div>
      <form @submit.prevent="recherche()" class="column is-5 pdr-0 pdl-0">
        <b-input
          :placeholder="$t('general.button.search')"
          type="search"
          v-model="criteresRecherche.auto"
          icon="magnify"
          >
        </b-input>
      </form>
      <div class="column is-narrow">
        <button class="button" @click="setShowFiltre">
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">
            {{ $t("general.button.filtre") }}
            <label  class="has-text-weight-bold"
              :class="nombreCritere > 0 ? '' : 'is-invisible'">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span @click="reinitialiser()"
          class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
    </template>
    <template #bar-right>
      <div class="column is-narrow">
        <exportExcelButton
              :perm="permCatalogue.exporter"
              :query="exportExcelQuery"/>
      </div>
      <div>
        <parametrage-table
          v-if="startArrayRendering"
          :reference-table="referenceTable">
        </parametrage-table>
      </div>
    </template>
    <template #content>
      <v-server-table
        url=""
        v-if="startArrayRendering"
        :columns="columns"
        :options="options"
        @loaded="finLoading"
        @loading="debutLoading"
        :ref="referenceTable">
        <template slot="afterTable">
          <table-items-in-view @input="$refs[referenceTable].setLimit($event)" />
        </template>
        <template slot="selected" slot-scope="props">
          <div class="has-text-centered">
            <b-checkbox v-model="props.row.selected"
              :value="props.row">
            </b-checkbox>
          </div>
        </template>
        <template slot="reference" slot-scope="props">
          <router-link
            :to="{ name: 'c.bodac.catalogue-reseauNumerique',
              params: { id: props.row.id, isFromListeProduitReseauNum: true } }"
            :class="{'text-access-no-permission': !checkPermissions(permCatalogue.lecture)}"
            class="lien">
              {{ props.row.reference }}
          </router-link>
        </template>
        <template slot="libelle" slot-scope="props">
          {{ props.row.libelle }}
        </template>
        <template slot="ProduitReseauNumerique.Adresse.Ville " slot-scope="props">
          {{ props.row.produitReseauNumerique.adresse.ville }}
        </template>
        <template slot="format" slot-scope="props">
          {{ getFormatLibelle(props.row.produitReseauNumerique.formatId) }}
        </template>
        <template slot="actif" slot-scope="props">
          {{ getLibelleActif(props.row.actif) }}
        </template>
        <template slot="typeReseau" slot-scope="props">
          {{ getTypeReseauLibelle(props.row.produitReseauNumerique.typeReseauId) }}
        </template>
        <template slot="nbEcrans" slot-scope="props">
          <div class="is-pulled-right">
            {{ props.row.produitReseauNumerique.affectationsReseauEcran.length }}
          </div>
        </template>
        <template slot="regroupementProduit" slot-scope="props">
          <span v-if="props.row.regroupementProduit">
            <router-link-blank
              :to="{ name: 'c.bodac.catalogue-detailRegroupementProduit',
                params: { id: props.row.regroupementProduit.id }}"
              :message="props.row.regroupementProduit.code"/>
          </span>
        </template>
        <template slot="agence" slot-scope="props">
          {{ getAgenceLibelle(props.row.agenceId) }}
        </template>
        <template slot="societe" slot-scope="props">
          {{ getLibelleSociete(props.row.supportCommercial.societeId) }}
        </template>
        <template slot="edit" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              @is-click="$router.push({
                name: 'm.bodac.catalogue-editionReseauNumerique',
                params: { produitId: props.row.id },
              })"
              :permission="permCatalogue.maj"
              :disabled="isModifiableIntoHolding(props.row)"
              :tooltip-label="$t('general.button.edit')"
              icon-type="is-success"
              icon="pencil-box-outline">
            </btn-action-icon>
          </div>
        </template>
        <template slot="archiver" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              :tooltip-label="getLabelTooltip(props.row)"
              :disabled="isSynchronized(props.row) || isModifiableIntoHolding(props.row)"
              :permission="permCatalogue.supprimer"
              :tooltip-position="!!getLabelTooltip(props.row) ? 'is-left' : 'is-top'"
              @is-click="openPopUpArchivage(props.row)"
              icon-type="is-default"
              :icon="props.row.actif ? 'archive' : 'archive-arrow-up'">
            </btn-action-icon>
          </div>
        </template>
        <template slot="delete" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              :tooltip-label="$t('general.button.delete')"
              :disabled="!checkPermissions(permCatalogue.supprimer) ||
                isModifiableIntoHolding(props.row)"
              :permission="permCatalogue.supprimer"
              @is-click="checkPermissions(permCatalogue.supprimer)
                ? openPopUpDelete(props.row) : showPopUp()"
              icon-type="is-danger"
              icon="delete-forever">
            </btn-action-icon>
          </div>
        </template>
      </v-server-table>
      <transition name="custom-classes-transition"
        enter-active-class="animate__animated animate__slideInRight"
        leave-active-class="animate__animated animate__slideOutRight" :duration="10">
        <div class="componentBrief" v-show="showFiltre === true">
          <filtre-liste-produit-reseau-numerique
            :isCartographie="false"
            ref="filtreListeProduitReseauNumerique"
            @toggleFiltre="setShowFiltre"
            @recherche="makeRechercheFilter()"/>
        </div>
      </transition>
      <b-modal v-model="popUpArchivage"
        has-modal-card
        class="modal"
        @close="produitToArchive = null">
        <pop-up-prevention v-if="produitToArchive"
          :messHeader="$t(produitToArchive.actif
            ? 'listeProduitReseauNumerique.archivage.archiver'
            : 'listeProduitReseauNumerique.archivage.desarchiver')"
          :messagesPopup="messagesErreurPopUp"
          :isErrorPopup.sync="errorPopUp"
          :cancel="$t('listeProduitReseauNumerique.archivage.no')"
          :validate="$t('listeProduitReseauNumerique.archivage.yes')"
          @no="popUpArchivage = false"
          @yes="archiverProduit()"/>
      </b-modal>
      <b-modal v-model="popUpDelete" has-modal-card
        class="modal"
        @close="produitToDelete = null">
        <pop-up-prevention v-if="produitToDelete"
          :mess-header="$t('suppressionProduitReseau.suppression.supprimer')"
          :messagesPopup="messagesErreurPopUp"
          :isErrorPopup.sync="errorPopUp"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="popUpDelete = false"
          @yes="supprimerProduit()"/>
      </b-modal>
    </template>
  </liste-template>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import listeTemplate from '@/components/general/template/listeTemplate';
import filtreListeProduitReseauNumerique from '@/components/catalogue/filtre/filtreListeProduitReseauNumerique';
import messageSucces from '@/services/general/messageSucces';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import popUpPrevention from '@/components/general/popUpPrevention';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { archiver } from '@/api/produit/produitNumerique';
import {
  CATEGORIE_DIVERS,
  CATEGORIE_LOCATION,
  EXPORT_EXCEL_PRODUIT_RESEAU_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import parametrageTable from '@/components/general/parametrageTable';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { columnsSplice } from '@/services/general/columns';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { REFERENCE_TABLE_PRODUIT_RESEAU_NUMERIQUE } from '@/configuration/general/referenceTableConf';
import { deleteReseau as deleteReseauNumerique } from '@/api/produit/produitReseauNumerique';
import validationProduit from '@/services/catalogue/validation/validationProduit';

const Permissions = createNamespacedHelpers('permissions');
const Societes = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const ProduitReseauNumerique = createNamespacedHelpers('produitReseauNumerique');

export default {
  data() {
    return {
      showFiltre: false,
      permCatalogue: CATALOGUE,
      popUpArchivage: false,
      produitToArchive: null,
      popUpDelete: false,
      produitToDelete: null,
      popUpEdition: false,
      unsubscribeValue: null,
      startArrayRendering: false,
      listeEtats: traductionLibelleEtat(this.$i18n, ETAT_DISPOSITIF_PUBLICITAIRE),
      referenceTable: REFERENCE_TABLE_PRODUIT_RESEAU_NUMERIQUE,
      errorPopUp: false,
      messagesErreurPopUp: [],
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  components: {
    filtreListeProduitReseauNumerique,
    parametrageTable,
    popUpPrevention,
    breadcrumb,
    selecteurAction,
    TableItemsInView,
    listeTemplate,
    BtnActionIcon,
    routerLinkBlank,
    exportExcelButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societes.mapGetters({
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
      agenceActive: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...ProduitReseauNumerique.mapGetters({
      produitsReseauNumerique: 'produits',
      totalCount: 'totalProduits',
      criteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    iconSelectTotal() {
      if (this.allProduitReseauNumerique) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allProduitReseauNumerique() {
      return this.getAllProduitReseauNumerique().length === this.produitsReseauNumerique.length
          && this.produitsReseauNumerique.length > 0;
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'actif', 'dateVisualisation'];
      if (this.societeActive.agences.length === 1) banCritereKey.push('agencesId');
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      if (this.criteresRecherche.actif !== null) nbCritere += 1;
      nbCritere += this.criteresRecherche.dateVisualisation !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = [
        'selected',
        'reference',
        'libelle',
        'ProduitReseauNumerique.Adresse.Ville ',
        'format',
        'typeReseau',
        'nbEcrans',
        'agence',
        'societe',
        'regroupementProduit',
        'actif',
        'edit',
        'archiver',
        'delete',
      ];
      if (
        this.societesInformations.length === 1
          || this.filtrerProduitParSociete
          || this.filtrerProduitParAgence
      ) {
        columnsSplice(columns, 'societe');
      }
      if (this.user.agences.length <= 1) {
        columnsSplice(columns, 'agence');
      }
      if (!this.modulePresseActive) {
        columnsSplice(columns, 'regroupementProduit');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('listeProduitReseauNumerique.tabs.reference'),
          libelle: this.$i18n.t('listeProduitReseauNumerique.tabs.libelle'),
          societe: this.$i18n.t('listeProduitReseauNumerique.tabs.societe'),
          'ProduitReseauNumerique.Adresse.Ville ': this.$i18n.t('listeProduitReseauNumerique.tabs.ville'),
          format: this.$i18n.t('listeProduitReseauNumerique.tabs.format'),
          typeReseau: this.$i18n.t('listeProduitReseauNumerique.tabs.type'),
          nbEcrans: this.$i18n.t('listeProduitReseauNumerique.tabs.nbEcran'),
          agence: this.$i18n.t('listeProduitReseauNumerique.tabs.agence'),
          actif: this.$i18n.t('listeProduitReseauNumerique.tabs.actif'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: [
          'reference',
          'libelle',
          'ProduitReseauNumerique.Adresse.Ville ',
          'format',
          'typeReseau',
        ],
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (this.user.agences.length === 1) {
            data.query.agencesId = [this.user.agences[0].agenceId];
          }
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.loadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produitsReseauNumerique,
            count: this.totalCount,
          };
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_PRODUIT_RESEAU_NUMERIQUE,
        typeExport: null,
        filtres: {
          ...this.lastPayload,
          Query: {
            ...this.lastPayload.Query,
            currentSociete: this.societeActiveId,
          },
        },
      };
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    breadcrumb() {
      return [
        {
          title: this.$i18n.t('listeProduitReseauNumerique.breadcrumb.racine'),
          route: this.$PAGE_DEFAULT,
          isActive: false,
        },
        { title: this.$i18n.t('listeProduitReseauNumerique.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societes.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...ProduitReseauNumerique.mapActions({
      loadProduits: 'loadProduitsReseauNumerique',
    }),
    getFormatLibelle(id) {
      const formatFind = this.parametre(PARAMETRES_KEYS.format).find((format) => {
        return format.id === id;
      });
      return formatFind ? formatFind.libelle : null;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeProduitReseauNumerique.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getAgenceLibelle(agenceId) {
      return this.agencesInformations.find((agence) => {
        return agence.agenceId === agenceId;
      })?.libelleAgence ?? '';
    },
    getLabelTooltip(produit) {
      let label = produit.actif ? this.$t('general.button.archiver') : this.$t('general.button.desarchiver');
      if (this.isSynchronized(produit)) label = this.$t('catalogue.info.produitSynchro');
      if (this.isModifiableIntoHolding(produit)) label = this.$t('catalogue.info.isNotModifiableIntoHolding');
      return label;
    },
    getTypeReseauLibelle(id) {
      const typeReseauFind = this.parametre(PARAMETRES_KEYS.typeReseau).find((typeReseau) => {
        return typeReseau.id === id;
      });
      return typeReseauFind ? typeReseauFind.libelle : null;
    },
    getAllProduitReseauNumerique() {
      return this.produitsReseauNumerique.filter((el) => { return el.selected; });
    },
    getLibelleActif(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    openPopUpArchivage(produit) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.produitToArchive = produit;
      this.popUpArchivage = true;
    },
    openPopUpDelete(produit) {
      this.produitToDelete = produit;
      this.popUpDelete = true;
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
    },
    async archiverProduit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.produitToArchive.id, this.produitToArchive.actif);
        messageSucces(this.$i18n.t(this.produitToArchive.actif
          ? 'listeProduitReseauNumerique.archivage.sucessArchivage'
          : 'listeProduitReseauNumerique.archivage.successDesarchivage'));
        this.produitToArchive = null;
        this.popUpArchivage = false;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          this.messagesErreurPopUp = validationProduit(e.response);
          this.errorPopUp = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async supprimerProduit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteReseauNumerique(this.produitToDelete.id);
        messageSucces(this.$i18n.t('suppressionProduitReseau.suppression.successDelete'));
        this.produitToDelete = null;
        this.popUpDelete = false;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        this.produitToArchive = null;
        if (e.response.data.error) {
          this.errorPopUp = true;
          this.messagesErreurPopUp = validationProduit(e.response);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getLibelleSociete(societeId) {
      return this.societesInformations.find((societe) => {
        return societe.id === societeId;
      })?.libelle ?? '';
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    selectAll() {
      const select = !this.allProduitReseauNumerique;
      this.produitsReseauNumerique.forEach((el) => {
        el.selected = select;
      });
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    updateAgenceAndRecherche() {
      if (this.filtrerProduitParAgence) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.recherche();
    },
    async reinitialiser() {
      await this.$refs.filtreListeProduitReseauNumerique.initializeFiltre();
      this.$refs.filtreListeProduitReseauNumerique.viderCritere();
      this.$refs.filtreListeProduitReseauNumerique.appliquerCritere();
      this.showFiltre = false;
    },
    isSynchronized(produit) {
      return produit.produitReseauNumerique !== null
        && produit.produitReseauNumerique.materielId !== null;
    },
    isModifiableIntoHolding(produit) {
      return produit.supportCommercial.societeId !== this.societeActiveId
        && produit.supportCommercial.categorieVente !== CATEGORIE_LOCATION
        && produit.supportCommercial.categorieVente !== CATEGORIE_DIVERS;
    },
  },
  beforeDestroy() {
    if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
      this.unsubscribeValue();
    }
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
      ]);
      if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      }
      if (this.user.agences.length > 1) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.startArrayRendering = true;
      this.setInformationPage(this.$t('pageGescom.produitReseauNumerique.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
